

// 加到普通div上提供weblog主动上报
import { LongTap } from '@src/slide/infrastructure/module/independent/ui/long-tap';

export const registerLongTapReportDialog = (duration = 5000): any => {
    const showReportLogDialog = () => {
        global.log?.loadAsset('WL_REPORT_DIALOG');
    };

    /**
     * 长按调起weblog主动上报
     */
    const longTapToWeblog = () => {
        LongTap.getInstance().longTap(showReportLogDialog, duration);
    };

    /**
     * 鼠标中途抬起或移开时取消
     */
    const cancelLongTap = () => {
        LongTap.getInstance().cancelLongTap();
    };

    return {
        onMouseDown: longTapToWeblog,
        onMouseMove: cancelLongTap,
        onMouseUp: cancelLongTap,
        onMouseLeave: cancelLongTap,
        onTouchStart: longTapToWeblog,
        onTouchMove: cancelLongTap,
        onTouchEnd: cancelLongTap,
    };
};
